import { useEffect, useState } from "react";
import { notifyError } from "../../utils/notify";
// Optional: install with `npm install emoji-picker-react`
import EmojiPicker from "emoji-picker-react";

export function UserForm({ onSubmit, initialData }) {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    icon: "", // store emoji here
    user_id: initialData?.id || "",
  });
  
  // Control the visibility of the emoji picker
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  useEffect(() => {
    setFormData({
      first_name: initialData?.first_name || "",
      last_name: initialData?.last_name || "",
      username: initialData?.username || "",
      email: initialData?.email || "",
      icon: initialData?.icon || "",
      user_id: initialData?.id || "",
    });
  }, [initialData]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle emoji selection (if using an emoji picker library)
  const handleEmojiClick = (emojiData) => {
    // Some libraries return (emojiData) with 'emoji' property
    setFormData((prev) => ({
      ...prev,
      icon: emojiData.emoji,
    }));
    setShowEmojiPicker(false);
  };

  // Validate the required fields and submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.first_name) {
      notifyError("First Name is required");
      return;
    }
    if (!formData.last_name) {
      notifyError("Last Name is required");
      return;
    }
    if (!formData.username) {
      notifyError("Username is required");
      return;
    }
    if (!formData.email) {
      notifyError("Email is required");
      return;
    }

    // Pass data up to parent
    onSubmit(formData);
    
    // Optionally reset the form
    setFormData({
      first_name: "",
      last_name: "",
      username: "",
      email: "",
      icon: "",
    });
  };

  return (
    <div className="pt-6">
      <form onSubmit={handleSubmit} className="space-y-4">
        
        {/* Save button */}
        <div className="flex justify-start">
          <button type="submit" className="bg-yellow-500 text-white px-4 py-2 rounded-lg">
            Save
          </button>
        </div>

        {/* First Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700">First Name</label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>
        
        {/* Last Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Last Name</label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>

        {/* Username */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Username</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
          />
        </div>

        {/* Icon (Emoji) */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Icon (Emoji)</label>
          <div className="flex items-center">
            {/* Display chosen icon */}
            <div className="mr-3 text-2xl">{formData.icon || "😀"}</div>
            
            {/* Toggle button for emoji picker */}
            <button
              type="button"
              onClick={() => setShowEmojiPicker((prev) => !prev)}
              className="bg-blue-500 text-white px-3 py-1 rounded-md"
            >
              Pick Emoji
            </button>
          </div>

          {/* Emoji picker (conditionally rendered) */}
          {showEmojiPicker && (
            <div className="mt-2">
              <EmojiPicker
                onEmojiClick={handleEmojiClick}
                autoFocusSearch={false}
              />
            </div>
          )}
        </div>
        
      </form>
    </div>
  );
}
